"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Inner = exports.ContentScrollbar = exports.Content = void 0;
var _mui = require("@ori-ui/mui");
const Inner = exports.Inner = (0, _mui.styled)('div')(({
  theme
}) => ({
  height: '100%',
  padding: theme.spacing(0, 0, 4, 0)
}));
const ContentScrollbar = exports.ContentScrollbar = (0, _mui.styled)('div')(({
  theme
}) => ({
  height: '100%',
  overflowY: 'auto',
  padding: theme.spacing(0, 2)
}));
const Content = exports.Content = (0, _mui.styled)(_mui.ScopedCssBaseline)({
  gridArea: 'content',
  height: '100%',
  padding: 0
});
